module.exports = __webpack_public_path__ + "static/media/instagram.ede1570f.png";